import { FontWeights, Text, neutral } from "@flat-ui";
import { Box } from "@mui/material";
import FeedbackIntroIllustration from "@assets/illustrations/feedback-intro-illustration.svg?react";

/** Intro screen body shown before the survey starts */
export function AnalyticsFeedbackIntroBody(): JSX.Element {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Text variant="heading20">
        Can you see how your workspace is really being used?
      </Text>

      <Text variant="bodyM" color={neutral[600]}>
        We're rebuilding workspace analytics — data volume, who did what, and
        what's actually getting viewed and used. We know it doesn't show
        everything yet. That's exactly what we're fixing.
      </Text>

      <FeedbackIntroIllustration />
      <Text variant="bodyM" color={neutral[600]}>
        Tell us what it has to get right.
        <Box
          component="span"
          sx={{ fontWeight: FontWeights.Bold, color: neutral[800] }}
        >
          {" "}
          3 quick questions, about a minute.
        </Box>
      </Text>
    </Box>
  );
}
